import {
  CollageElementDataType,
  ImageElementDataType,
} from '@/components/sections/builder/elements/body/collage/type';
import ImageSetting from '@/components/sections/builder/settings/image-setting';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import { ElementProps } from '@/components/sections/builder/types';
import useMediaQuery from '@/hooks/useMediaQuery';
import { cn } from '@/lib/utils';

import { useBuilderStore } from '@/stores/builder';
import { Tags } from 'lucide-react';
import React from 'react';
import { shallow } from 'zustand/shallow';

const defaultData: ImageElementDataType = {
  name: 'Image',
  image: 'https://placehold.co/600x600?text=Placeholder+Image',
  mobileMinWidth: 720,
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as ImageElementDataType;
  const parentData = (element.parentData || {}) as CollageElementDataType;

  const imgUrl = useMediaQuery(data.mobileMinWidth) && data.mobileImg ? data.mobileImg : data.image;

  return (
    <>
      <div
        className={cn('w-full', parentData.cardStyle === 'all' && 'theme_product_card')}
        style={{ height: '100%' }}
      >
        <div className='image_padding' style={{ height: '100%' }}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            className={cn(
              'img w-full object-cover',
              parentData.cardStyle === 'individual' && 'theme_media'
            )}
            src={imgUrl}
            style={{ height: '100%' }}
            alt='image'
          />
        </div>
      </div>
    </>
  );
};

export const ElementPreviewIcon = Tags;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as ImageElementDataType;

  return (
    <div>
      <div className='mb-4 mt-4 font-bold'>Image</div>
      <ImageSetting
        value={data?.image}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            image: val,
          })
        }
      />
      <div className='mb-2 mt-4'>Mobile image (optional)</div>
      <ImageSetting
        value={data?.mobileImg}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, {
            mobileImg: val,
          });
        }}
      />
      <InputSlider
        label='Device under this size use mobile image'
        value={data.mobileMinWidth || 0}
        max={1440}
        min={0}
        rightContent={<div>px</div>}
        onChange={(val) =>
          builder.setChildData(element.parentId as string, element.id, {
            mobileMinWidth: val,
          })
        }
      />
    </div>
  );
}

const Product = {
  type: 'image',
  group: 'collage',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default Product;
